import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import nbrApi from '../../../services/nbrApi'
import Swal from 'sweetalert2'
import MappingForm from '../../components/MangeHKT/MappingForm'

function EditMapping() {
    const navigate = useNavigate()
    const { id } = useParams()
    // const [selectedProperty, setSelectedProperty] = useState({})
    // const [selectedRoomType, setSelectedRoomType] = useState({})
    // const [data, setData] = useState([])
    const [selectedItem, setSelectedItem] = useState({})
    const manage_hkt_data = JSON.parse(localStorage?.getItem('edit-manage-hkt')) || {}

    // handleGoBack
    const handleGoBack = () => {
        navigate('/manage-requests')
        localStorage.removeItem('edit-manage-hkt')
    }

    // create action
    const handleForm = async (propsData) => {
        const { property, roomType, task, taskGroups, taskProcess, workStages } = propsData
        if (propsData) {
            try {
                const data = {
                    mhkt_id: manage_hkt_data.mhkt_id,
                    properties_id: property,
                    ws_id: Number(workStages),
                    tp_id: taskProcess,
                    tg_id: taskGroups,
                    mririt_id: Number(task),
                    rt_id: roomType
                  };
                const response = await nbrApi.post('/updateflatmap2', data, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (response.status === 200) {
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Mapping Updated successful',
                        showConfirmButton: false,
                        timer: 2000,
                    }).then(() => {
                        handleGoBack();
                    });
                }
            } catch (error) {
                console.error('Error fetching data:', error.message)
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Mapping Updated failed',
                    showConfirmButton: false,
                    timer: 2000,
                })
            }
        } else {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: 'Mapping Updated failed',
                showConfirmButton: false,
                timer: 2000,
            })
        }

    }

    // // fetch data 
    // async function fetchList() {
    //     let property = JSON.parse(localStorage.getItem('selectedProperty')) || null
    //     let roomType = JSON.parse(localStorage.getItem('selectedRoomType')) || null

    //     setSelectedProperty(property)
    //     setSelectedRoomType(roomType)

    //     const url = BASE_PATH + `/get_mhkt_list?properties_id=${property?.value}&roomtypes_id=${roomType?.value}`

    //     try {
    //         const response = await fetch(url)

    //         if (!response.ok) {
    //             throw new Error(`HTTP error! Status: ${response.status}`)
    //         }

    //         const responseData = await response.json()
    //         setData(responseData)
    //         if(responseData?.length > 0){
    //             let filterData = responseData?.filter(e => e?.mhkt_id === parseInt(id))?.[0] || {}
    //             setSelectedItem(filterData)
    //         }

    //     } catch (error) {
    //         console.error('Error fetching data:', error.message)
    //     }
    // }

    // // init
    // useEffect(() => {
    //     if (id) {
    //         fetchList()
    //     }
    // }, [id])

    // useEffect(() => {
    //     let selectedData = JSON.parse(localStorage.getItem('edit-mapping-default')) || {}
    //     setSelectedItem(selectedData)
    // },[])

    // render
    return (
        <div className="row">
            <div className="col-xxl-12">
                <div className="card">
                    <div className="card-header">
                        <h4 className="heading me-2">Edit Mapping</h4>
                        <button type='button' onClick={handleGoBack} className='btn btn-primary btn-sm'>Back to List</button>
                    </div>

                    <div className="card-body col-lg-5">
                        <MappingForm handleAction={handleForm} />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditMapping